import { createFileRoute } from '@tanstack/react-router';

import { TemplatePage } from '@pages/templates/template-page.js';
import { IamService } from '@units/iam';

/**
 * `/templates/$templateId` — wiring only (`rules/frontend-fsd.mdc` правило 10).
 *
 * `whenDenied: 'forbidden'`, тот же выбор, что у перечня: форма не секрет внутри организации,
 * секрет — только чужая. `404` на чужую/несуществующую форму отдаёт сервер (`GET /templates/{id}`),
 * решает это он, не гард.
 */
export const Route = createFileRoute('/_authenticated/templates/$templateId')({
  beforeLoad: IamService.IamGuards.requirePermission({
    permission: 'template:read',
    whenDenied: 'forbidden',
  }),
  component: TemplatePage,
  staticData: { crumbKey: 'templates.card.title' },
});
